/* eslint-disable import/no-extraneous-dependencies */
import i18n from 'lib/i18n'

const translate = i18n('client')

const intl = {
    save: 'save',
    cancel: 'cancel',
    lastName: 'lastName',
    'postCode&Locality': 'postCode&Locality',
    locality: 'locality',
    postalCode: 'postalCode',
    street: 'street',
    number: 'number',
    extension: 'extension',
    country: 'country',
    dateOfBirth: 'dateOfBirth',
    gender: 'gender',
    language: 'language',
    emails: 'emails',
    phoneNumbers: 'phoneNumbers',
    default: 'default',
    phone: 'phone',
    mobile: 'mobile',
    ok: 'ok',
    add: 'clientAdd',
    value: (value) => value === 'email' ? 'email' : 'phoneNumber',
    addNewItem: (value) => value === 'email' ? 'addEmailAddress' : 'addPhoneNumber',
    modalTitle: (value) => value === 'email' ? 'infoModalEmailAddressCanNotDeleteTitle' : 'infoModalPhoneNumberCanNotDeleteTitle',
    modalContent: (value) => value === 'email' ? 'infoModalEmailAddressCanNotDeleteDescription' : 'infoModalPhoneNumberCanNotDeleteDescription',
    modalConfirmCancel: 'pleaseConfirmCancel',
    modalConfirmCancelContent: 'pleaseConfirmDeleteContent',
    requiredField: 'requiredField',
    invalidBirthDate: 'invalidBirthDate',
    emailsRequired: 'emailsRequired',
    phoneNumbersRequired: 'phoneNumbersRequired',
    requiredDefaultEmail: 'requiredDefaultEmail',
    requiredDefaultPhone: 'requiredDefaultPhone',
    invalidEmail: 'invalidEmail',
    invalidPhoneNumber: 'invalidPhoneNumber',
    modifyClientMyEasinsureSuccess: 'modifyClientMyEasinsureSuccess',
    modifyClientMyEasinsureError: 'modifyClientMyEasinsureError',
    modifyClientMyEasinsureErrorGeneral: 'modifyClientMyEasinsureErrorGeneral',
    attention: 'attention',
    defaultEmailChangedMessage: 'defaultEmailChangedMessage',
}

export { intl, translate }



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/client-profile-form/translation.js